import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=5f399e0e&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"
import style0 from "./Clients.vue?vue&type=style&index=0&id=5f399e0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f399e0e",
  null
  
)

export default component.exports